import {useSelector} from 'react-redux';

import {isUserLoggedIn} from 'app/reducers/commonData/selectors';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useUserRole = () => {
    const isCurrentUserLoggedIn = useSelector(isUserLoggedIn);
    return {isAdmin: isCurrentUserLoggedIn, isGuest: !isCurrentUserLoggedIn};
};
